// ── Nacherfassung: freefield link preview (FMT-3499) ────────────────────────
// Link-looking input in a freefield is mirrored as a clickable link below the
// field (div#link-for-<name>). Rendered on the detail/edit page.
(function () {
    'use strict';

    if (!document.querySelector('input.freefield_input')) return;

    function updateFreefieldLink(input) {
        var value = (input.value || '').trim();
        var isLink = false;
        var hasProtocol = false;

        // Order of the four checks is significant (kept from legacy code).
        if (/^https?:\/\/../.test(value)) { isLink = true; hasProtocol = true; }
        // Roughly: "dimedis.de" or "bla.dimedis.de/foo" (no protocol) counts.
        if (/^[a-zA-Z0-9-]+\.[a-zA-Z0-9.-]+([^ ]*)?$/.test(value)) isLink = true;
        // Numbers like 1.300.000 are not domains.
        if (/^[0-9.]+$/.test(value)) isLink = false;
        // Characters that could break HTML suppress the link output.
        if (/['"<>\n]/.test(value)) isLink = false;

        var linkDiv = document.getElementById('link-for-' + input.name);
        if (!linkDiv) return;

        if (isLink) {
            var a = document.createElement('a');
            a.href = hasProtocol ? value : 'https://' + value;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            a.textContent = value;
            linkDiv.replaceChildren(a);
            linkDiv.hidden = false;
            linkDiv.style.removeProperty('display'); // older templates render style="display:none"
        } else {
            linkDiv.replaceChildren();
            linkDiv.hidden = true;
        }
    }

    // 'input' instead of legacy 'keyup': also catches paste and autofill.
    document.addEventListener('input', function (e) {
        if (e.target instanceof Element && e.target.matches('input.freefield_input')) {
            updateFreefieldLink(e.target);
        }
    });

    // Initial pass: a stored value may already be a link.
    document.querySelectorAll('input.freefield_input').forEach(updateFreefieldLink);
})();
